import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, message } from 'antd';
import { refreshTrends } from '@store/common/actions';
import { clearCache } from '@src/api/cacheAdapter/config';
import useKPI from '@src/hooks/useKPI';
import { OVERVIEW_LABELS } from '@src/utils/kpi';

const KpiDeleteModal = ({ kpiValues, currentKpi, isModalOpen, discardDeleteHandler, panelRef }) => {
  const dispatch = useDispatch();
  const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
  const { deleteKpiMutation } = useKPI();
  const { ACTIVE_KPI_DELETE_CONFIRMATION, OTHER_KPI_DELETE_CONFIRMATION } = OVERVIEW_LABELS;

  const setDeletedKpiHandler = () => {
    setIsDeleteLoading(true);
    deleteKpiMutation.mutate(kpiValues.kpiID, {
      onSuccess: () => {
        message.info(`${kpiValues.kpiName} KPI has been deleted successfully.`);
        setIsDeleteLoading(false);
        discardDeleteHandler();
        if (kpiValues.kpiID === currentKpi?.kpiID) {
          clearCache(); // clear axios cache as threshold changed
          dispatch(refreshTrends());
        }
      },
      onError: () => {
        message.error('There was an error deleting KPI. Please try again later.');
        discardDeleteHandler();
        setIsDeleteLoading(false);
      },
    });
  };

  const footerButtons = [
    <Button key="discard" onClick={discardDeleteHandler}>
      Discard
    </Button>,
    <Button key="save" type="primary" onClick={setDeletedKpiHandler} loading={isDeleteLoading}>
      Proceed
    </Button>,
  ];

  return (
    <Modal
      width="500px"
      title="Delete Custom KPI"
      open={isModalOpen}
      onCancel={discardDeleteHandler}
      footer={footerButtons}
      wrapClassName="kpi-delete-modal"
      getContainer={() => panelRef.current}
    >
      <p>
        {kpiValues.kpiID === currentKpi?.kpiID
          ? ACTIVE_KPI_DELETE_CONFIRMATION
          : OTHER_KPI_DELETE_CONFIRMATION}
      </p>
    </Modal>
  );
};

export default KpiDeleteModal;
